import { useL10n } from "@ews/react-localization-context";
import { IonInputCustomEvent } from "@ionic/core";
import { InputChangeEventDetail, IonInput, IonItem, IonLabel, IonModal, IonPopover } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { globalDebounceTime } from "../../../../../../setup/locale";
import style from "../../SettingsRangeInput.module.scss";
import rangeStyle from "./DatePicker.module.scss";
import { DatePickerProps, Value } from "./types";
import { deepEqual } from "../../../../../../utils";
import { ensureUtc } from "../../../../../../generic/date";


const formatter = new Intl.DateTimeFormat('sv-SE', { dateStyle: 'short', timeStyle: 'short' });

export const dateFormat = (date: Date) => formatter.format(date).replace(" ", "T");


export const dateRange = (date: Date, days: number, iso: boolean = false) =>
{

    const toDate = new Date(date.getTime());
    toDate.setHours(0, 0, 0, 0);
    toDate.setDate(toDate.getDate() + 1);

    const fromDate = new Date(toDate.getTime());
    fromDate.setDate(fromDate.getDate() - days);

    return {
        from: !iso ? dateFormat(fromDate) : `${fromDate.toISOString().replace(/.\d\d\dZ/, "Z")}`,
        to: !iso ? dateFormat(toDate) : `${toDate.toISOString().replace(/.\d\d\dZ/, "Z")}`
    };

};
export const dateStringToValue = (s: string): Value =>
{
    let [from, to] = s.split(",");

    [from] = from.split("@");
    if (to) [to] = to.split("@");

    return {
        from,
        to: to || from
    };
};

export const valueToDateString = (v: Value, timeZone?: string): string =>
{
    timeZone = timeZone ? `@${timeZone}` : '';
    return `${v.from}${timeZone},${v.to}${timeZone}`;
};

const DatePicker: React.FC<DatePickerProps> = ({
    value,
    onChange,
    onBlur,
    title,
    className,
    id,
    divider = true,
    position = "line",
    presentation = "date-time",
    childText
}) =>
{
    const { translate: t } = useL10n();
    const [range, setRange] = useState(value);

    useEffect(() =>
    {
        setRange(pre =>
        {
            if (!deepEqual(value, pre)) {
                return value;
            }
            return pre;
        });

    }, [value, setRange]);

    const handleChange = (type: 'from' | 'to', event: IonInputCustomEvent<InputChangeEventDetail>) =>
    {
        try {
            const data = (event as any).detail.value ? { ...range, [type]: (event as any).detail.value } : { ...range };
            setRange(data);

            if (onChange) {

                const from = ensureUtc(data.from!);
                const to = ensureUtc(data.to!);

                // const test = new Date(to!);
                // const fmt = new Intl.DateTimeFormat('sv-SE', { dateStyle: 'short', timeStyle: 'short', timeZone: "Europe/Vienna" });

                // //console.log(fmt.format(test));

                onChange({ from, to });
            }
        }
        catch (err) {
            console.log("Exception in DatePicker.tsx in handleChange", err, event);
        }
    };

    return <IonItem className={` ${className}`} id={id}>
        {title ? <div style={{ width: "100%" }}>
            <IonLabel style={{ width: "fit-content", margin: "0 auto" }} >{t(title)}</IonLabel>
        </div> : null
        }
        <div className={`${position === "line" ? style.line : style.row}`}>
            <section>
                {childText?.start ? <div >
                    <IonLabel className={`${rangeStyle.label}`}>{t(childText?.start)}</IonLabel>
                </div> : null}
                <IonInput
                    label=""
                    aria-label="from"
                    type="datetime-local"
                    value={range.from?.replace("Z", "")}
                    debounce={globalDebounceTime}
                    onIonInput={(e) =>
                    {
                        handleChange('from', e);
                    }}
                />
            </section>
            {divider ? <div className={`${rangeStyle.devider}`}>{" __ "}</div> : null}
            <section>

                {childText?.end ? <div >
                    <IonLabel className={`${rangeStyle.label}`}>{t(childText?.end)}</IonLabel>
                </div> : null}
                <IonInput
                    label=""
                    aria-label="to"
                    type="datetime-local"
                    value={range.to?.replace("Z", "")}
                    debounce={globalDebounceTime}
                    onIonInput={(e) =>
                    {
                        handleChange('to', e);
                    }} />
            </section>

        </div>
    </IonItem >;
};

export default DatePicker;
